export default "__VITE_ASSET__CzNehQjx__"